"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("./constants");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Divider = function Divider(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _constants.COLORS.GRAY : _ref$color;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.default.root, className, _styles.default["color--".concat(color)])
  });
};
Divider.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(Object.values(_constants.COLORS))
};
var _default = exports.default = Divider;